import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReasonBlocked } from "src/models/Maintenance/ReasonBlocked";

interface ReasonBlockedState {
  reasonBlockeds: IReasonBlocked[];
  reasonBlockedToEdit: IReasonBlocked | null;
}

const initialState: ReasonBlockedState = {
  reasonBlockeds: [],
  reasonBlockedToEdit: null,
};

const reasonBlockedSlice = createSlice({
  name: "ReasonBlocked",
  initialState,
  reducers: {
    setReasonBlockedList: (state, action: PayloadAction<IReasonBlocked[]>) => {
      state.reasonBlockeds = action.payload;
    },
    concatListReasonBlocked: (
      state: ReasonBlockedState,
      action: PayloadAction<IReasonBlocked[]>
    ) => {
      state.reasonBlockeds = [...state.reasonBlockeds.concat(action.payload)];
    },
    setReasonBlockedToEdit: (
      state,
      action: PayloadAction<IReasonBlocked | null>
    ) => {
      state.reasonBlockedToEdit = action.payload;
    },
    addReasonBlocked: (state, action: PayloadAction<IReasonBlocked>) => {
      state.reasonBlockeds.push(action.payload);
    },
    updateReasonBlocked: (state, action: PayloadAction<IReasonBlocked>) => {
      let itemIndex = state.reasonBlockeds.findIndex(
        item => item.reasonBlockedId === action.payload.reasonBlockedId
      );
      if (itemIndex !== -1) state.reasonBlockeds[itemIndex] = action.payload;
    },
    deleteReasonBlocked: (state, action: PayloadAction<number>) => {
      const newArray = state.reasonBlockeds.filter(
        item => item.reasonBlockedId !== action.payload
      );
      state.reasonBlockeds = newArray;
    },
  },
});

export const {
  setReasonBlockedList,
  concatListReasonBlocked,
  setReasonBlockedToEdit,
  addReasonBlocked,
  updateReasonBlocked,
  deleteReasonBlocked,
} = reasonBlockedSlice.actions;

export default reasonBlockedSlice.reducer;
